<template>
    <div class="wrap-aktivasi">
        <div v-if="loading">
            <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <p>Loading...</p>
        </div>
        <div v-else class="wrap-content" v-show="status != ''">
            <img src="../assets/abi-vertical.png" alt="" class="img-title" />
            <div class="title">Status Aktivasi Email</div>
            <div class="content">
                <div v-if="status == 498">
                    <h6>Link sudah kadaluarsa.</h6>
                    <div>
                        Silahkan masukkan email Anda untuk mendapatkan link aktivasi email baru
                        <div class="form-group">
                            <input type="text" name="" id="" placeholder="Masukkan email anda" class="form-input" v-model="$v.reEmail.$model" />
                            <div v-if="$v.reEmail.$error">
                                <div class="error" v-if="!$v.reEmail.required">No email tidak bolah kosong</div>
                                <div class="error" v-else-if="!$v.reEmail.email">format email salah</div>
                            </div>
                        </div>
                        <button class="btn btn-primer" @click="resendEmail">
                            <b-spinner v-if="isLoading" small></b-spinner>
                            <span v-else>Kirim</span>
                        </button>
                    </div>
                </div>
                <div v-else-if="status == 9002" class="text-center">
                    <h5>
                        Akun sudah aktif
                    </h5>
                    <div>
                        Silahkan login untuk melanjutkan tahap selanjutnya <br />
                        <button class="btn btn-primer" @click="login">Login</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { required, email } from "vuelidate/lib/validators";

export default {
    data() {
        return {
            status: "",
            loading: false,
            reEmail: "",
            error: "",
            isLoading: false,
        };
    },
    validations: {
        reEmail: {
            required,
            email,
        },
    },
    mounted() {
        let id = this.$route.params.id;
        localStorage.clear();
        delete axios.defaults.headers.common["Authorization"];
        this.loading = true;
        axios
            .post("/v2/user/register/verify/email/" + id)
            .then((res) => {
                localStorage.setItem("url_demo", res.data.data.demo_url);
                this.loading = false;
                if (res.data.data.status_code == "00") {
                    this.status = res.data.data.status_code;
                    this.$router.push("/welcome");
                } else {
                    this.status = res.data.data.status_code;
                }
            })
            .catch((error) => {
                this.loading = false;
                this.status = error.response.status;
            });
    },
    methods: {
        resendEmail() {
            this.$v.reEmail.$touch();
            if (this.$v.reEmail.$error) {
                return;
            }

            this.isLoading = true;
            axios
                .post("/v2/user/register/resend/email", {
                    email: this.reEmail,
                })
                .then((res) => {
                    this.isLoading = false;
                    this.status = res.data.status;
                    if (this.status == 200) {
                        this.$notify({
                            group: "foo",
                            title: "<h5>Link aktivasi email berhasil dikirm</h5>",
                            type: "success",
                            duration: 2000,
                        });
                        this.$router.go("/login");
                    }
                })
                .catch((err) => {
                    if (err.response.data.data.status_code == "9002") {
                        this.status = err.response.data.data.status_code;
                    } else {
                        this.$toast.error(err.response.data.data.err_message);
                    }
                    this.isLoading = false;
                });
        },
        login() {
            this.$router.push("/login");
        },
    },
};
</script>

<style scoped>
.re-register {
    color: #6454f0;
    cursor: pointer;
    margin-top: -5px;
}
.wrap-aktivasi {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    flex-direction: column;
    background: rgba(197, 151, 51, 0.4);
}

.img-title {
    height: 98px;
    margin-bottom: 40px;
}

.wrap-content .title {
    width: 90%;
    background: #1e354a;
    border-radius: 5px 5px 0 0;
    color: #ffffff;
    padding: 10px 20px;
    box-shadow: 0px 8px 20px 0px rgb(0 0 0 / 15%);
    text-align: center;
    font-weight: bold;
}

.wrap-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.wrap-content .content {
    width: 100%;
    background: white;
    padding: 25px 45px;
    border-radius: 5px;
    box-shadow: 0px 8px 20px 0px rgb(0 0 0 / 15%);
}

.form-input {
    width: 100%;
    margin: 1rem 0 0 0;
}

.btn-primer {
    margin-top: 2rem;
}

.lds-ring {
    display: inline-block;
    position: relative;
    width: 50px;
    height: 50px;
    /* background: black; */
    top: -6px;
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 50px;
    height: 50px;
    margin: 8px;
    border: 8px solid #6454f0;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #6454f0 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@media (max-width: 768px) {
    .wrap-content .content {
        width: 90%;
    }

    .wrap-content .title {
        width: 80%;
    }

    .img-title {
        height: 70px;
    }

    .btn {
        width: 100%;
    }

    .btn-primer {
        max-width: 100%;
    }
}
</style>
